import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import { RiskItem } from "components/summary/success-plan";
import { Control, Controller } from "react-hook-form";

type RiskSelectControllerProps = {
  control: Control<any>;
  riskItems: RiskItem[];
  name: string;
  required?: boolean;
};

const RiskSelectController = ({
  control,
  riskItems,
  name,
  required = false,
}: RiskSelectControllerProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field, fieldState }) => (
        <FormControl
          error={!!fieldState.error}
          variant="outlined"
          size="small"
        >
          <Select
            {...field}
            style={{
              width: "240px",
            }}
            MenuProps={{
              sx: {
                "&&:active": {
                  boxShadow: (theme) => theme.shadows[8],
                },
              },
            }}
            size="small"
            value={field.value ?? ""}
            displayEmpty
            onChange={(e) => {
              field.onChange(e);
              field.onBlur();
            }}
            renderValue={(value) => {
              if (!value) {
                return <span style={{ color: "#878787" }}>Select One</span>;
              }

              const selectedItem = riskItems.find((item) => item.value === value);
              return selectedItem ? (
                <span style={{ color: selectedItem.color }}>{selectedItem.value}</span>
              ) : null;
            }}
          >
            {riskItems.map((item) => (
              <MenuItem
                key={item.key}
                value={item.value}
                style={{ color: item.color }}
              >
                {item.value}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{fieldState.error ? fieldState.error.message : ""}</FormHelperText>
        </FormControl>
      )}
      rules={{
        required: {
          message: "The field is required.",
          value: required,
        },
      }}
    />
  );
};

export default RiskSelectController;
